/*
 * @Author: yzr
 * @Date: 2020-11-24 09:37:03
 * @LastEditors: yzr
 * @LastEditTime: 2020-11-25 11:00:33
 */
import Terminal from './terminal.vue';

export default Terminal;
